import React from "react";
import { createColumnHelper } from "@tanstack/react-table";
import Tag from "ui-components/molecules/tag/tag";
import { cn } from "../../../services/common/className";

const columnHelper = createColumnHelper<any>();

const getFormattedDate = (date: string) => {
  if (!date) return "";
  return date.toUiDateFormat()
}

const getFormattedRealizedAmount = (acceptedAmount: number) => {
  return (acceptedAmount) ? <Tag mix={cn("cell__realized-amount")("amount")}>
    {acceptedAmount.toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
    })}
  </Tag>
    : <Tag mix={cn("cell__realized-amount")("no-amount")}>
      --
    </Tag>
}

export const getAccessorialsRevenueDailyTrendColumns = () => [
    columnHelper.accessor("dateAdded", {
      header: "Date",
      id: "dateAdded",
      size: 40,
      cell: (cellProps: any) => (
        <>
          {getFormattedDate(cellProps.row.original.dateAdded)}
        </>
      )
    }),
    columnHelper.accessor("scannedShipments", {
      header: "Shipments Scanned",
      id: "scannedShipments",
      size: 50,
      cell: (cellProps: any) => (
        <>
          {cellProps.row.original.scannedShipments}
        </>
      )
    }),
    columnHelper.accessor("scannedShipments", {
      header: "Findings",
      id: "findings",
      size: 50,
      cell: (cellProps: any) => (
        <>
          {cellProps.row.original.operationsPending + cellProps.row.original.operationsAccepted + cellProps.row.original.operationsRejected}
        </>
      )
    }),
    columnHelper.accessor("operationsPending", {
      header: "Operations Pending",
      id: "operationsPending",
      size: 50,
      cell: (cellProps: any) => (
        <>
          {cellProps.row.original.operationsPending}
        </>
      )
    }),
    columnHelper.accessor("operationsAccepted", {
      header: "Operations Accepted",
      id: "operationsAccepted",
      size: 50,
      cell: (cellProps: any) => (
        <>
          {cellProps.row.original.operationsAccepted}
        </>
      )
    }),
    columnHelper.accessor("operationsRejected", {
      header: "Operations Rejected",
      id: "operationsRejected",
      size: 50,
      cell: (cellProps: any) => (
        <>
          {cellProps.row.original.operationsRejected}
        </>
      )
    }),
    columnHelper.accessor("billingPending", {
      header: "Billing Pending",
      id: "billingPending",
      size: 50,
      cell: (cellProps: any) => (
        <>
          {cellProps.row.original.billingPending}
        </>
      )
    }),
    columnHelper.accessor("billingAccepted", {
      header: "Billing Accepted",
      id: "billingAccepted",
      size: 50,
      cell: (cellProps: any) => (
        <>
          {cellProps.row.original.billingAccepted}
        </>
      )
    }),
    columnHelper.accessor("billingRejected", {
      header: "Billing Rejected",
      id: "billingRejected",
      size: 50,
      cell: (cellProps: any) => (
        <>
          {cellProps.row.original.billingRejected}
        </>
      )
    }),
    columnHelper.accessor("acceptedAmount", {
      header: "Realized Amount",
      id: "acceptedAmount",
      size: 50,
      cell: (cellProps: any) => (
        <>
          {getFormattedRealizedAmount(+cellProps.row.original.acceptedAmount)}
        </>
      )
    })
  ];